import React from 'react';
import { useDragLayer } from 'react-dnd';
import PageNotFoundIllustration from '../../images/generatingPreview.png';
import { CustomDragContainer, ThumbnailPreview } from '../../components/EditorElement/styles';
import { correctBaseUrl } from '../../utils/svgUtils';
import { PAGE_NUMBER } from '../../utils/complexDocumentConstants';

const CustomDragLayer = ({ scaling, applyTransparency = false, types = ['elements', PAGE_NUMBER] }) => {
  const {item, itemType, isDragging, initialClientOffset, initialCursorOffset, clientOffset, cursorOffset} = useDragLayer(monitor => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    isDragging: monitor.isDragging(),
    initialClientOffset: monitor.getInitialSourceClientOffset(),
    initialCursorOffset: monitor.getInitialClientOffset(),
    clientOffset: monitor.getSourceClientOffset(),
    cursorOffset: monitor.getClientOffset()
  }));
  if (!isDragging || !types.includes(itemType) || item.element.icon !== undefined || item.element.emailElement || item.element.isTemplate) {
    return null;
  }
  const display = (!initialClientOffset || !clientOffset) ? "none" : "";
  let scaledTransform = undefined;
  if (clientOffset && cursorOffset && item.boundaries && item.element?.elementDetails?.styles) {
    let { x, y } = clientOffset;
    let { x: cursorX, y: cursorY } = cursorOffset;
    const { width: originalW, height: originalH } = item.boundaries;
    let { width, height } = item.element.elementDetails.styles;
    width = parseInt(width.replace("px", ""));
    height = parseInt(height.replace("px", ""));
    width = width * scaling;
    height = height * scaling;

    let xOffset = initialCursorOffset.x - initialClientOffset.x;
    let yOffset = initialCursorOffset.y - initialClientOffset.y;
    const widthRatio = xOffset / originalW;
    xOffset = width * widthRatio;
    const heightRatio = yOffset / originalH;
    yOffset = height * heightRatio;

    x = (cursorX - xOffset);
    y = (cursorY - yOffset);
    scaledTransform = `translate(${x}px, ${y}px)`;
  }
  const element = item.element;
  const elementWidth = parseInt(element.elementDetails?.styles?.width?.replace("px", ""), 10);
  const elementHeight = parseInt(element.elementDetails?.styles?.height?.replace("px", ""), 10);

  return (
    <CustomDragContainer>
      <div
        style={{
          display,
          transform: scaledTransform,
          position: 'absolute',
          width: elementWidth * scaling,
          height: elementHeight * scaling
        }}
      >
        {element?.elementDetails.type === "text"
          ? (<div
            style={{ width: elementWidth,
              height: elementHeight,
              transformOrigin: "0 0",
              transform: `scale(${scaling})`
            }}
            dangerouslySetInnerHTML={{__html: element.elementDetails.value}} />)
          : element?.isFillable ? (
            <div
              style={{
                width: elementWidth,
                height: elementHeight,
                transformOrigin: '0 0',
                transform: `scale(${scaling})`,
                position : element?.elementDetails?.tagName === 'combobox' && 'relative',
                opacity: applyTransparency ? 0.5 : 1
              }}
              dangerouslySetInnerHTML={{ __html: element.thumbnail }}
            />
          ) :element?.elementDetails.type === "static_table" ? <div
          style={{ width: elementWidth,
            height: elementHeight,
            transformOrigin: "0 0",
            transform: `scale(${scaling})`
          }}
          dangerouslySetInnerHTML={{__html: element.htmlContent}} />: (<ThumbnailPreview
            src={element.thumbnail ? correctBaseUrl(element.thumbnail) : PageNotFoundIllustration}
            alt='loading...'
            className={!element.thumbnail ? 'no-thumbnail' : ''}
            style={{
              width: elementWidth,
              height: elementHeight,
              transformOrigin: "0 0",
              transform: `scale(${scaling})`,
              opacity: applyTransparency ? 0.5 : 1
            }}
          />)}
      </div>
    </CustomDragContainer>
  )
}

export default React.memo(CustomDragLayer);